export default {
  back: '이전으로 돌아가기',
  refresh: '새로고침',
  backHome: '메인으로 돌아가기',
}
